import React from "react";

// Only the Travel QR journey (journeyType === "QR_TRAVEL") is live right now.
// Every other journey entry point renders this instead of its real page.
const JourneyBlocked = () => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",
      padding: "24px",
      textAlign: "center",
      fontFamily: "sans-serif",
    }}
  >
    <h2>This journey is currently unavailable</h2>
    <p>Please use the link provided to you to continue.</p>
  </div>
);

export default JourneyBlocked;
